import React, { useEffect } from "react";

import { ajustaActiveClassMenu } from "../../../util/rotinas";

import ContentHeader from "../../../components/ContentHeader";

import logo from '../../../assets/logo.png' 

export default function Home() {
  
  useEffect(() => {
    ajustaActiveClassMenu("dashMenu", "dashMenu");
  }, []);

  return (
    <div>
      <ContentHeader
        urlPrevious="#"
        previousTitle="Home"
        smallTitle="Dashboard"
      />

      <>
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <img
            style={{ width: "300px", height: "100px", marginTop: "200px" }}
            src={logo}
            alt=""
          />
        </div>
      </>
    </div>
  );
}
